import { StyleSheet } from 'aphrodite';
import { titles } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 14,
		height: '100%',
		justifyContent: 'center',
	},
	feedbackContainer: {
		textAlign: 'center',
		width: '100%',
	},
	feedbackInput: {
		height: 150,
		resize: 'none',
	},
	feedbackLabel: {
		marginBottom: 14,
	},
	intro: {
		margin: '63px 0 28px',
	},
	ratingStar: {
		height: 42,
		width: 42,
	},
	ratingContainer: {
		marginBottom: 45,
	},
	submitButton: {
		width: '100%',
		marginBottom: 48,
	},
});
